import { ECountries } from '@/_types';
import { getUrlParams } from '../get-url-locale-params';

type TParams = {
  locale?: string;
  country?: string;
};

export const getLocaleUrl = ({ country, locale }: TParams): string => {
  const { country: currentCountry, locale: currentLocale } = getUrlParams();

  const isCnLocale =
    country === ECountries.ZH ||
    currentCountry === ECountries.ZH ||
    country === ECountries.CN ||
    currentCountry === ECountries.CN;

  // eslint-disable-next-line @portals/custom-plugin/todo-checker
  // TODO: rewrite with envs when boiler update is ready
  const portalPath = window.location.pathname.match('/about-portal')
    ? '/about-portal'
    : '';

  // We don't need locale in /about-portal/en or /about-portal/zh yet - will be removed after old landing will be moved in archive
  const urlLocale = isCnLocale ? '' : locale || currentLocale;

  const url = `${portalPath}/${country || currentCountry}/${urlLocale}`;
  const searchParamsString = new URLSearchParams(
    window.location.search,
  ).toString();

  return searchParamsString ? `${url}?${searchParamsString}` : url;
};
